import {motion} from "framer-motion";

export default function RoomBox({children, style}) {
    return (
        <motion.div
            initial={{opacity: 0, translateY: 500}}
            animate={{opacity: 1, translateY: 0}}
            exit={{opacity: 0, scale: 0.5}}
            className={`relative flex flex-col overflow-mx-4 mt-24 w-[90vw] md:w-[80vw] 2xl:w-[70vw] h-[80vh] bg-white rounded-[16px] overflow-hidden ${style}`}>
            {children}
        </motion.div>
    );
}
